// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PackagesList_pageHeader__2OUln","warnMessage":"PackagesList_warnMessage__1uW7v"};